import { useEffect, useRef } from 'react'
import { Modal, Button, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { removePrivateTalentInit } from '../../../../redux/actions';
import "./PopupModal.css"

const PopupModal = ({ show, onClose, id, absAccountId }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const triggered = useRef(false);
  const { loadingPrivate, removePrivateStatus, RemoveTalentPrivate } = useSelector(
    (state) => state.getProfileDetailsReducer
  );

  useEffect(() => {
    if (!triggered.current || loadingPrivate) return;
    triggered.current = false;

    const config = {
      success: { notify: message.success, fallback: 'Candidate removed from private marketplace' },
      failure: { notify: message.error,   fallback: 'Failed to remove candidate. Please try again.' },
    }[removePrivateStatus];

    config?.notify(RemoveTalentPrivate?.message || config.fallback);

    if (removePrivateStatus === 'success') {
      history.push('/employerdashboard');
    }
  }, [loadingPrivate, removePrivateStatus, RemoveTalentPrivate]);

  const handleOk = () => {
    triggered.current = true;
    dispatch(removePrivateTalentInit({ id, absAccountId }));
    onClose();
  };

  return (
    <Modal
      title={<div className='removeMsg'>Remove candidate from private marketplace?</div>}
      onCancel={onClose}
      open={show}
      footer={[
        <Button key="back" className='backBtn' onClick={onClose}>No</Button>,
        <Button key="submit" className='submitBtn' type="primary" onClick={handleOk}>Yes</Button>,
      ]}
    >
      <p className='msg'>
        Are you sure you want to remove this candidate from private marketplace?
        Candidate will lose the private tag and will no longer be able to see your private jobs.
      </p>
    </Modal>
  );
}

export default PopupModal